var AppModule = /** @class */ (function () {
    function AppModule() {
    }
    return AppModule;
}());
export { AppModule };



// WEBPACK FOOTER //
// ./src/app/app.module.ts.pre-build-optimizer.js